import { ref } from 'vue';
import RealEstateCommissionInstallmentsAPI from 'dashboard/api/realEstateCommissionInstallments';

export function useSalesCommissionMeiDownload({ t }) {
  const downloadingId = ref(null);
  const error = ref('');

  const download = async ({ installmentId, filename }) => {
    if (!installmentId || downloadingId.value) return null;

    downloadingId.value = installmentId;
    error.value = '';
    try {
      const response =
        await RealEstateCommissionInstallmentsAPI.downloadMeiReceipt(
          installmentId
        );
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename || `Recibo_de_MEI_${installmentId}.docx`;
      link.click();
      window.URL.revokeObjectURL(url);
      return true;
    } catch (downloadError) {
      error.value = t('SALES.DETAIL.COMMISSION.MEI.DOWNLOAD_ERROR');
      return null;
    } finally {
      downloadingId.value = null;
    }
  };

  return { download, downloadingId, error };
}
